<template>
  <el-form
    class="bg-white"
    style="padding: 15px"
    label-position="top"
    v-loading="isLoading"
    :rules="rules"
    ref="inspectionSheet"
    :model="inspectionSheet"
  >
    <h4 class="form-title">Material Receiving Inspection Sheet</h4>
    <el-alert
      v-show="!is_readonly"
      :closable="false"
      type="warning"
      title="Material Receiving Inspection Sheet is required to input stock-in batch items."
    >
    </el-alert>
    <el-row :gutter="15">
      <el-col :sm="12">
        <el-form-item label="Date Received" prop="date_received">
          <el-date-picker v-model="inspectionSheet.date_received" type="date">
          </el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :sm="12">
        <el-form-item label="Time Received" prop="time_received">
          <el-time-picker
            v-model="inspectionSheet.time_received"
            format="HH:mm"
          >
          </el-time-picker>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :sm="12">
        <el-form-item label="Supplier's Name" prop="supplier_name">
          <el-input
            v-model="inspectionSheet.supplier_name"
            :readonly="true"
            placeholder="Supplier will be assigned based on the PO selected."
          ></el-input>
          <!-- <el-select v-model="inspectionSheet.supplier_id">
            <el-option
              v-for="s in suppliers"
              :label="s.name"
              :key="s.id"
              :value="s.id"
            >
            </el-option>
          </el-select> -->
        </el-form-item>
      </el-col>
      <el-col :sm="12">
        <el-form-item label="P.O. Number" prop="po_id" v-show="!is_readonly">
          <el-select
            v-model="inspectionSheet.po_id"
            :loading="isFetching"
            filterable
            remote
            reserve-keyword
            @change="po_changed"
          >
            <el-option
              v-for="s in openPO"
              :label="s.po_no"
              :key="s.id"
              :value="s.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="P.O. Number" v-show="is_readonly" prop="po_id">
          <el-input v-model="inspectionSheet.po_no" :readonly="true"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :sm="12">
        <el-form-item label="Delivery Note No." prop="delivery_note_no">
          <el-input v-model="inspectionSheet.delivery_note_no"></el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="12">
        <el-form-item label="Invoice No." prop="invoice_no">
          <el-input
            v-model="inspectionSheet.invoice_no"
            :readonly="is_readonly && user.isRole([2, 3, 4])"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :sm="12">
        <el-form-item label="Freight Forwarder" prop="freight_forwarder">
          <el-input v-model="inspectionSheet.freight_forwarder"></el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="12">
        <el-form-item label="Batch No." prop="batch_no">
          <el-input
            :readonly="true"
            placeholder="generated after saving"
            v-model="inspectionSheet.batch_no"
          ></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <h5>Documentation</h5>
        <el-row>
          <el-col :sm="16">
            <el-form-item label="The following matches with the Purchase Order">
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-radio-group v-model="inspectionSheet.match_po">
              <el-radio :label="1">Yes</el-radio>
              <el-radio :label="0">No</el-radio>
              <el-radio :label="2">N/A</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="16">
            <el-form-item label="The following matches with the Part Number">
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-radio-group v-model="inspectionSheet.match_part_no">
              <el-radio :label="1">Yes</el-radio>
              <el-radio :label="0">No</el-radio>
              <el-radio :label="2">N/A</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="16">
            <el-form-item label="The following matches with the Description">
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-radio-group v-model="inspectionSheet.match_part_description">
              <el-radio :label="1">Yes</el-radio>
              <el-radio :label="0">No</el-radio>
              <el-radio :label="2">N/A</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <h5>Certificate</h5>
        <el-form-item>
          <el-checkbox-group v-model="inspectionSheet.certificates">
            <el-checkbox :label="1" name="certificate">EASA Form 1</el-checkbox>
            <el-checkbox :label="2" name="certificate">GCAA Form 1</el-checkbox>
            <el-checkbox :label="3" name="certificate">FAA 8130-3</el-checkbox>
            <el-checkbox :label="4" name="certificate">TCCA Form</el-checkbox>
            <el-checkbox :label="5" name="certificate"
              >Certificate of Conformity</el-checkbox
            >
            <el-checkbox :label="6" name="certificate">Others</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <h5>Packing Condition</h5>
        <el-row>
          <el-col :span="16">
            <el-form-item label="Hidden damages"> </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-radio-group v-model="inspectionSheet.hidden_damage">
              <el-radio :label="1">Yes</el-radio>
              <el-radio :label="0">No</el-radio>
              <el-radio :label="2">N/A</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="Visible damages"> </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-radio-group v-model="inspectionSheet.visible_damages">
              <el-radio :label="1">Yes</el-radio>
              <el-radio :label="0">No</el-radio>
              <el-radio :label="2">N/A</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="16">
            <el-form-item label="Adequate protective packaging"> </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-radio-group v-model="inspectionSheet.adequate_packaging">
              <el-radio :label="1">Yes</el-radio>
              <el-radio :label="0">No</el-radio>
              <el-radio :label="2">N/A</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <h5>Materials Physical Inspection</h5>
        <el-row>
          <el-col :sm="16">
            <el-form-item label="Item damaged, nicks, dents, breaks, etc...">
            </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-radio-group v-model="inspectionSheet.item_damage">
              <el-radio :label="1">Yes</el-radio>
              <el-radio :label="0">No</el-radio>
              <el-radio :label="2">N/A</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="16">
            <el-form-item label="Apparent leakage"> </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-radio-group v-model="inspectionSheet.apparent_leakage">
              <el-radio :label="1">Yes</el-radio>
              <el-radio :label="0">No</el-radio>
              <el-radio :label="2">N/A</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="16">
            <el-form-item label="Quantity complete"> </el-form-item>
          </el-col>
          <el-col :sm="8">
            <el-radio-group v-model="inspectionSheet.quantity_complete">
              <el-radio :label="1">Yes</el-radio>
              <el-radio :label="0">No</el-radio>
              <el-radio :label="2">N/A</el-radio>
            </el-radio-group>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <el-form-item label="Remarks">
      <el-input type="textarea" v-model="inspectionSheet.remarks"></el-input>
    </el-form-item>
    <!-- <el-row :gutter="15">
      <el-col :sm="12">
        <el-form-item label="Received and inspected by">
          <el-input :readonly="true" v-model="user_info"></el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="12">
        <el-form-item label="Position">
          <el-input :readonly="true" v-model="user_type"></el-input>
        </el-form-item>
      </el-col>
    </el-row> -->
    <el-row :gutter="15">
      <el-col :sm="12">
        <el-form-item label="Received and inspected by" prop="requested_by">
          <el-input v-model="inspectionSheet.requested_by"></el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="12">
        <el-form-item label="Position" prop="requested_by_position">
          <el-input v-model="inspectionSheet.requested_by_position"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="15">
      <el-col :sm="12">
        <!-- <el-form-item label="E-Signature" prop="e_signature"> -->
        <!-- <el-upload
            :action="api.href"
            :headers="api.headers"
            accept="image/*"
            :data="{ q: 'esign' }"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="beforeUpload"
          >
            <el-button size="small" type="primary">Upload</el-button>
          </el-upload> -->
        <!-- <img
            class="img-responsive"
            v-if="!inspectionSheet.id"
            :src="userSignature"
            alt="e_signature"
          /> -->
        <!-- <img
            class="img-responsive"
            v-else
            :src="`data:image/jpg;base64,${inspectionSheet.image}`"
            alt="e_signature"
          /> -->
        <!-- </el-form-item> -->
        <!-- <img :src="inspectionSheet.e_signature" /> -->
      </el-col>
    </el-row>
    <div class="d-flex pt-2">
      <el-button type="primary" size="small" @click="save">Save</el-button>
      <!-- <el-button
        v-if="inspectionSheet.id"
        type="primary"
        size="small"
        @click="print"
        >Print</el-button
      > -->
      <router-link
        v-if="inspectionSheet.id"
        :to="{
          name: 'print_inspectionSheet',
          params: { id: inspectionSheet.id }
        }"
        target="_blank"
        class="el-button el-button--primary el-button--small"
        >Print</router-link
      >
      <el-button size="small" @click="cancel">Cancel</el-button>
    </div>
  </el-form>
</template>
<script>
import api from "@/api";
import moment from "moment";
import InspectionSheet from "@/models/InspectionSheet";
import PurchaseOrder from "@/models/PurchaseOrder";
// import User from "@/models/User";
export default {
  name: "InspectionSheet",
  computed: {
    suppliers() {
      return this.$store.getters["supplier/glossary"];
    },
    api() {
      return {
        headers: {
          // "Content-Type": "multipart/form-data",
          Authorization: `${this.$store.getters["auth/token"].token_type} ${this.$store.getters["auth/token"].access_token}`,
          "X-Requested-With": "XMLHttpRequest"
        },
        href: new URL("/api/v1/inventory/fileupload/", api.baseUrl).href
      };
    },
    // user() {
    //   if (this.inspectionSheet.id) {
    //     this.receivedBy;
    //   }
    //   return this.$store.getters["auth/user"];
    // },
    // user_info() {
    //   return `${this.user.first_name} ${this.user.last_name}`;
    // },
    // user_type() {
    //   var userType = this.$store.getters["user/userTypes"].find(o => {
    //     return o.id == this.user.user_type;
    //   });
    //   return userType != undefined ? userType.name : "";
    // },
    // openPO() {
    //   return this.$store.getters["purchaseorder/openPO"].data;
    // },
    is_readonly() {
      if (this.inspectionSheet.id) {
        return true;
      }
      return false;
    },
    user() {
      return this.$store.getters["auth/user"];
    },
    userSignature() {
      if (this.user && this.user.signature) {
        return "data:image/jpg;base64," + this.user.signature;
      }
      return "";
    }
  },
  data() {
    return {
      isLoading: false,
      drawerState: false,
      inspectionSheet: new InspectionSheet(),
      isFetching: false,
      rules: InspectionSheet.rules(),
      receivedBy: null,
      imageUrl: "",
      openPO: []
    };
  },
  mounted() {
    if (this.$route.params && this.$route.params.id) {
      this.init();
    } else {
      var user = { ...this.$store.getters["auth/user"] };
      this.$store.dispatch("user/getUserTypes").then(() => {
        var userType = this.$store.getters["user/userTypes"].find(o => {
          return o.id == user.user_type;
        });
        this.inspectionSheet.requested_by = `${user.first_name} ${user.last_name}`;
        this.inspectionSheet.requested_by_position = userType.name;
        this.fetchList();
      });
    }
  },
  methods: {
    beforeUpload() {},
    // handleUploadSuccess(res, file) {
    // remove upload
    // handleUploadSuccess(res, file) {
    //   // console.log(res);
    //   if (
    //     res.hasOwnProperty("data") &&
    //     res.data.hasOwnProperty("code") &&
    //     res.data.code == 200
    //   ) {
    //     this.imageUrl = URL.createObjectURL(file.raw);
    //     this.inspectionSheet.e_signature = res.data.msg;
    //   } else {
    //     this.$notify({
    //       type: "error",
    //       message: res.data.msg,
    //       position: "bottom-right",
    //     });
    //   }
    // },
    // print() {
    //   this.$router.push({
    //     name: "print_inspectionSheet",
    //     params: { id: this.inspectionSheet.id }
    //   });
    // },
    cancel() {
      this.$router.push({ name: "batchcontrol" });
    },
    init() {
      this.isLoading = true;
      InspectionSheet.fetch(this.$route.params.id).then(resp => {
        if (resp) {
          this.isLoading = false;
          this.inspectionSheet = new InspectionSheet(resp);
          // User.fetch(this.inspectionSheet.received_by).then(resp => {
          //   this.receivedBy = resp;
          // });
          var vuexObj = { ...this.inspectionSheet };
          this.imageUrl = "data:image;base64, " + resp.image;
          this.$store.dispatch("stockin/setInspectionSheet", vuexObj);
        } else {
          this.$notify({
            type: "warning",
            message: "Inspection Sheet not found.",
            position: "bottom-right"
          });
          this.$router.push({ name: "batchcontrol" });
        }
      });
    },
    fetchList() {
      // if (query !== "") {
      // this.isFetching = true;
      // var params = {
      //   limit: 10,
      //   po_no: query,
      //   status: 1
      // };
      // this.$store.dispatch("purchaseorder/getOpenPO", params).then(() => {
      //   this.isFetching = false;
      // });
      PurchaseOrder.getOpenPO().then(list => {
        this.isFetching = false;
        if (list) {
          this.openPO = list;
        }
      });
      // }
    },
    po_changed() {
      if (this.inspectionSheet.po_id) {
        var po = this.openPO.find(o => {
          return o.id == this.inspectionSheet.po_id;
        });
        if (po) {
          this.inspectionSheet.po_no = po.po_no;
          this.inspectionSheet.supplier_name = po.supplier_name;
          this.inspectionSheet.supplier_id = po.supplier_id;
        }
      }
    },
    save() {
      this.$confirm(
        "Do you want to save this Material Receiving Inspection Sheet?",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }
      )
        .then(() => {
          this.$refs.inspectionSheet.validate(valid => {
            if (!valid) {
              return false;
            }

            var etc = {
              supplier_name: this.inspectionSheet.supplier_name,
              certificates: [...this.inspectionSheet.certificates],
              match_po: this.inspectionSheet.match_po,
              match_part_no: this.inspectionSheet.match_part_no,
              match_part_description: this.inspectionSheet
                .match_part_description,
              hidden_damage: this.inspectionSheet.hidden_damage,
              visible_damages: this.inspectionSheet.visible_damages,
              adequate_packaging: this.inspectionSheet.adequate_packaging,
              item_damage: this.inspectionSheet.item_damage,
              apparent_leakage: this.inspectionSheet.apparent_leakage,
              quantity_complete: this.inspectionSheet.quantity_complete,
              remarks: this.inspectionSheet.remarks,
              delivery_note_no: this.inspectionSheet.delivery_note_no,
              invoice_no: this.inspectionSheet.invoice_no,
              freight_forwarder: this.inspectionSheet.freight_forwarder,
              date_received: moment(this.inspectionSheet.date_received).format(
                "YYYY-MM-DD"
              ),
              time_received: moment(this.inspectionSheet.time_received).format(
                "HH:mm"
              ),
              po_no: this.inspectionSheet.po_no,
              po_no_id: this.inspectionSheet.po_no_id,
              requested_by: this.inspectionSheet.requested_by,
              requested_by_position: this.inspectionSheet.requested_by_position
              // user_id: this.$store.getters["auth/user"].id
            };
            var obj = {
              batch_no: this.inspectionSheet.batch_no,
              po_no_id: this.inspectionSheet.po_id,
              po_no: this.inspectionSheet.po_no,
              // e_signature: this.inspectionSheet.e_signature,
              data: JSON.stringify(etc),
              received_year: moment(this.inspectionSheet.date_received).format(
                "YY"
              )
            };
            this.isLoading = true;
            if (this.inspectionSheet.id) {
              obj.id = this.inspectionSheet.id;
              InspectionSheet.update(obj).then(resp => {
                this.isLoading = false;
                if (resp && resp.code == 200) {
                  this.$notify({
                    type: "success",
                    message:
                      "Material Receiving Inspection Sheet saved successfully.",
                    position: "bottom-right"
                  });
                  this.$router.push({
                    name: "batchcontrol"
                  });
                }
              });
            } else {
              InspectionSheet.create(obj).then(resp => {
                this.isLoading = false;
                if (resp && resp.code == 200) {
                  this.$notify({
                    type: "success",
                    message:
                      "Material Receiving Inspection Sheet saved successfully.",
                    position: "bottom-right"
                  });
                  if (!this.inspectionSheet.id) {
                    this.$router.push({
                      name: "batch_info",
                      params: { id: resp.id },
                      query: { tab: 2 }
                    });
                  }
                }
              });
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="scss" scoped>
.esign-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.esign-uploader:hover {
  border-color: #409eff;
}

.uploader-icon {
  // font-size: 28px;
  color: #8c939d;
  width: 100%;
  // height: 178px;
  // line-height: 178px;
  text-align: center;
}
</style>
